/**
 * GCB Phase 6 — Collection sub-chips active state.
 *
 * The chips on the collection page (templates/collection.json
 * sub_chips_phase4 section) currently all link to /collections/all
 * pending Jack's real handle list. Once handles arrive (each chip
 * pointing at /collections/<handle>), this script automatically
 * highlights the chip whose href matches the current URL pathname.
 *
 * Adds aria-current="page" + a CSS class for styling. The CSS rule
 * lives in assets/base.css under the GCB BRAND SYSTEM block.
 *
 * Until Jack's handles are wired, all chips point to /collections/all
 * so this is effectively a no-op (the All chip will always be marked
 * active on every collection page, which is at least semantically
 * defensible: "you are browsing within All collections").
 */

(function () {
  function markActiveChip() {
    // Scope to the sub-chips section. The section's name in JSON is
    // "Sub-collection chips" — Horizon renders sections with a wrapping
    // class derived from the section type. Best fingerprint: 5 button
    // chips inside a row-direction section block container.
    //
    // Safer selector: any section that contains exactly the 5 chips by
    // their button labels. We match all anchor links in any element that
    // looks like a chip group, but constrain by attribute href starting
    // with "/collections/".
    const chips = document.querySelectorAll('a.button-secondary[href^="/collections/"]');
    if (!chips.length) return;

    const path = window.location.pathname.replace(/\/$/, '');

    chips.forEach((chip) => {
      const href = chip.getAttribute('href').replace(/\/$/, '');
      const isActive = href === path;
      chip.classList.toggle('chip--active', isActive);
      if (isActive) {
        chip.setAttribute('aria-current', 'page');
      } else {
        chip.removeAttribute('aria-current');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markActiveChip);
  } else {
    markActiveChip();
  }
})();
